import Vue from 'vue'
import i18next from 'i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import VueI18Next from '@panter/vue-i18next'

import enTranslation from './en.json'

Vue.use(VueI18Next)

const DEFAULT_LANGUAGE = 'en'

// Locales are lazy-loaded using the strategy described here: https://www.i18next.com/how-to/add-or-load-translations#lazy-load-in-memory-translations
i18next
  .use(
    // eslint-disable-next-line no-unused-vars
    resourcesToBackend((language, namespace) => {
      // The "namespace" parameter has to be present (even if not used) for this function to be executed by the i18next-resources-to-backend plugin
      return import(`./.autotranslate/${language}.json`)
    })
  )
  .init({
    lng: DEFAULT_LANGUAGE,
    partialBundledLanguages: true,
    fallbackLng: DEFAULT_LANGUAGE,
    resources: {
      en: {
        translation: enTranslation,
      },
    },
  })

export default new VueI18Next(i18next)
